/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-blocked-domains" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-blocked-domains" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-blocked-domains" */ `./edit.vue` );
const Import = () => import( /* webpackChunkName: "group-blocked-domains" */ `./import.vue` );
const Settings = () => import( /* webpackChunkName: "group-blocked-domains" */ `./settings.vue` );

export default {
	path: `blocked-domains`,
	children: [
		{
			path: ``,
			name: `list-blocked-domains`,
			component: List,
			meta: {
				title: `Blocked Domains`
			}
		},
		{
			path: `import`,
			name: `import-blocked-domains`,
			component: Import,
			meta: {
				title: `Import Blocked Domains`
			}
		},
		{
			path: `settings`,
			name: `blocked-domain-settings`,
			component: Settings,
			meta: {
				title: `Blocked Domain Settings`
			}
		},
		{
			path: `new`,
			name: `add-blocked-domain`,
			component: Add,
			meta: {
				title: `Add Blocked Domain`
			}
		},
		{
			path: `:uuid`,
			name: `edit-blocked-domain`,
			component: Edit,
			meta: {
				title: `Edit Blocked Domain`
			}
		}
	]
};
